<template>

  <div>
    <div class="mainArea">
      <div v-if="!project">
        <h1>Projekte</h1>
        <div class="projectlist">
          <div class="projectlist-item" @click="setProject(project)" v-for="project in orderedProjects()" v-bind:key="project['.key']">
            <div class="projectlist-item-remove" @click="remove(project['.key'])" v-on:click.stop>
              <svgicon :icon="'delete'"  width="24" height="24" color="#334274"></svgicon>
            </div>
            <div class="projectlist-item-info">
              <h6>{{project.title}}</h6>
            </div>
          </div>
          <div class="projectlist-item projectlist-item-add" @click="newProject = true">
            <svgicon :icon="'add'" width="48" height="48" color="#334274"></svgicon>
          </div>
        </div>
      </div>
      <project v-if="project" @back="project = false" :project="project" @mapSelect="mapSelect($event)"></project>
      <selection-map @selected="selected($event)" @closeSelectionMap="mapSelection = false" v-if="mapSelection"></selection-map>
      <project-create-new v-if="newProject" @abortCreateNew="newProject = false" @setNew="createNewProject($event)"></project-create-new>
    </div>
  </div>

</template>

<script>
import firebase from 'firebase/app'
import VueAwesomplete from 'vue-awesomplete'
import AwesompleteCss from 'awesomplete/awesomplete.css' // eslint-disable-line
import Project from '@/components/Project' // eslint-disable-line
import SelectionMap from '@/components/SelectionMap' // eslint-disable-line
import moment from 'moment'
import ProjectCreateNew from '@/components/ProjectCreateNew'
import _ from 'lodash'

var db = firebase.database()
var areasRef = db.ref('areas')
var postsRef = db.ref('posts')
var projectsRef = db.ref('projects')

export default {
  name: 'Projects',
  components: {
    VueAwesomplete,
    Project,
    SelectionMap,
    ProjectCreateNew
  },
  data () {
    return {
      project: false,
      mapSelection: false,
      phase: false,
      newProject: false
    }
  },
  methods: {
    setProject: function (project) {
      this.project = project
    },
    mapSelect: function (phase) {
      this.phase = phase
      this.mapSelection = true
    },
    selected: function (post) {
      projectsRef.child(this.project['.key']).child('items').child(post).child('phase').set(this.phase)
      projectsRef.child(this.project['.key']).child('items').child(post).child('added').set(moment().format())
      this.mapSelection = false
      this.phase = false
    },
    remove (project) {
      var r = confirm('Sind Sie sicher, dass Sie dieses Projekt löschen möchten?')
      if (r === true) {
        projectsRef.child(project).remove()
      }
    },
    orderedProjects () {
      let dataPosts = this.projects // eslint-disable-line
      dataPosts = _.orderBy(dataPosts, ['added'], ['asc'])
      return dataPosts
    },
    createNewProject (data) {
      projectsRef.push({
        title: data.title,
        description: 'Hier können Sie eine Beschreibung hinzufügen.',
        added: moment().format()
      })
      this.newProject = false
    }
  },
  firebase () {
    return {
      areas: areasRef,
      posts: postsRef,
      projects: projectsRef
    }
  },
  computed: {
    projectPosts: function () {
      let dataPosts = this.posts // eslint-disable-line
      // let projectItems = this.pItems
      // let projectItems = projectsRef.child(this.project['.key']).child('items')
      // dataPosts = _.filter(dataPosts, function (v) { return console.log(projectItems) })
      // dataPosts = _.filter(dataPosts, function (v) { return console.log(_.intersection(v, projectItems)) })
      // dataPosts = _.filter(dataPosts, function (v) { return console.log(projectItems.includes(v['.key'])) })
      // dataPosts = _.intersection(v['.key'], projectItems)
      return dataPosts
    }
  }
}
</script>

<style lang="scss">

  .mainArea .main {
    width: 100% !important;
    left: 0;

    .mapFilterBox button:last-of-type {
      display: none !important;
    }
  }

  .projectlist {

      display: flex;
      // justify-content: space-between;
      // flex-direction: row;
      flex-wrap: wrap;
      max-width: 100%;
      margin-left: -12px;
      margin-right: -12px;
      // wdith: 960px;

  }

  .projectlist-item-remove {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 20px;
    top: 15px;
    svg path {
      fill: $color-grey;
    }
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }

  .projectlist-item {

    position: relative;
    z-index: 1;
    width: 300px;
    max-width: calc((100% / 3) - 25px);
    @media screen and (min-width:1280px) {
      max-width: calc((100% / 4) - 25px);
    }
    background: #fff;
    box-sizing: border-box;
    padding: 20px 20px 15px;
    box-shadow: 0 2px 5px 0 rgba($color-text,0.1);
    height: 200px;
    color: $color-action;
    margin-top: 25px;
    user-select: none;

    &.prio1 {
      border-bottom: 6px solid rgba($color-error, 1);
    }

    &.prio2 {
      border-bottom: 6px solid rgba($color-warn, 1);
    }

    &.greyout {
      background: rgba(#fff, 0.25);
      box-shadow: 0 2px 5px 0 rgba($color-text,0.025);
      .projectlist-item-info > span {
        opacity: 0.25;
      }
      .project-list-item-connections {
        opacity: 0.25;
      }
      h6 {
        opacity: 0.4;
      }
      &.prio1 {
        border-bottom: 6px solid rgba($color-error, 0.15);
      }

      &.prio2 {
        border-bottom: 6px solid rgba($color-warn, 0.15);
      }
    }

    &:not(.prio1):not(.prio2) {
      border-bottom: 6px solid transparent;
    }

    h6 span {
      font-weight: 400;
    }

    margin-left: 12.5px;
    margin-right: 12.5px;

    .projectlist-item-info {
        position: absolute;
        bottom: 15px;
        left: 20px;
        right: 20px;
        color: $color-grey;
        font-size: $font-size-small;
        svg {
          margin-top: -3px;
          margin-left: -6px;
          path {
            fill: rgba($color-action, 0.25);
          }
        }
        & > span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display:block;
          width: 100%;
          max-width: 100%;
        }
    }
    &:hover {
      cursor: pointer;
    }

   h6 {
    font-family: 'Dosis', sans-serif;
    font-size: $font-size-default;
    line-height: 1.4em;
    hyphens: auto;
    color: $color-action;
    margin-bottom: 2.5px;
    text-align: left;
   }

    &.--addnew {
      box-shadow: none;
      background: transparent;
      border: 1px solid rgba($color-action, 0.1);
      text-align: center;
      color: rbga($color-action, 0.2) !important;
      place-items: center center;
    }

  }

  .projectlist-item-add {
    background: transparent !important;
    box-shadow: none !important;
    border: 1px dashed rgba($color-action, 0.25);
    border-bottom: 1px dashed rgba($color-action, 0.25) !important;
    text-align: center;
    line-height: 160px;
    svg {
      opacity: 0.5;
    }
    &:hover {
      svg {
        opacity: 1;
      }
    }
    &.disabled {
      svg {
        opacity: 0.1 !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Projects.vue